<script setup>
    import { defineProps, defineEmits } from 'vue';
    //import { useReserveStore } from '@/stores/reserve/reserveStore';
    // ----------------------------
    // 定数
    // ----------------------------
    //const reserveStore = useReserveStore();

    // ----------------------------
    // Props
    // ----------------------------
    const props = defineProps({
        message: {
            type: String,
            default: '',
        },
    });

    // ----------------------------
    // Emits
    // ----------------------------
    const emit = defineEmits(['reserveCancelCompleteModal:close']);

    // ----------------------------
    // 関数
    // ----------------------------
    function onClose() {
        emit('reserveCancelCompleteModal:close');
    }
</script>

<style></style>

<template>
    <article id="modalYoyakuCancelComplete" class="modal small" :style="{ display: 'block' }">
        <p class="textCenter">{{ props.message }}</p>
        <section class="dialogFooter">
            <ul class="btnArea center">
                <li>
                    <button type="button" class="btnNormal" @click="onClose">{{ $t('common.parts.close') }}</button>
                </li>
            </ul>
        </section>
    </article>
</template>
